// frontend/src/slices/userLoginAuditApiSlice.js
import { apiSlice } from './apiSlice';
 
const USER_LOGIN_AUDIT_URL = '/api/user-login-audit';
 
export const userLoginAuditApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // All users grouped: { [userId]: [log, ...] }
    getAllLoginAudits: builder.query({
      query: () => ({ url: USER_LOGIN_AUDIT_URL }),
      keepUnusedDataFor: 60,
    }),
 
    // Single user
    getUserLoginAudit: builder.query({
      query: (userId) => ({ url: `${USER_LOGIN_AUDIT_URL}/${userId}` }),
      keepUnusedDataFor: 30,
    }),
 
    // Record logout — call this before clearing credentials
    // eventType: 'logout_manual' | 'logout_auto'
    recordLogout: builder.mutation({
      query: ({ eventType = 'logout_manual', note = '' }) => ({
        url:    `${USER_LOGIN_AUDIT_URL}/logout`,
        method: 'POST',
        body:   { eventType, note },
      }),
    }),
  }),
});
 
export const {
  useGetAllLoginAuditsQuery,
  useGetUserLoginAuditQuery,
  useRecordLogoutMutation,
} = userLoginAuditApiSlice;